import React from 'react';

import { UserActivation } from '@/modules/user';

const UserActivationPage = () => (
  <UserActivation />
);
export default UserActivationPage;
